import { ANCHORED_PLUGIN_POSITIONS } from "../const/anchored-plugin-positions.const";
import { DiagramEventEmitter } from "../../../diagram/modules/DiagramEventEmitter";
import { DIAGRAM_EMIT_EVENTS } from "../../../diagram/modules/DiagramEvents";

export const AnchoredPluginsHandler = (function () {
    const instance = {};
    class AnchoredPluginsHandler {
        plugins = new Map();

        instanceUuid;

        cellIndependentPluginHandler = null;

        connectingLineHandler = null;

        grid;

        selected;

        constructor(diagramInstanceUuid) {
            if (!instance[diagramInstanceUuid]) {
                // setting the singleton instance
                instance[diagramInstanceUuid] = this;
                this.instanceUuid = diagramInstanceUuid;
            }
            return instance[diagramInstanceUuid];
        }

        /**
         * @description Sets the provided anchored plugin as selected
         * @param {*} elem
         */
        setSelected(elem) {
            this.undoPreviousSelection(elem);
            this.selected = elem;
            if (this.selected) {
                const childrenObj = this.plugins.get(this.selected.key).children;
                const children = Object.keys(childrenObj);
                let child = children.find(child => childrenObj[child].instance.uuid === this.selected.uuid);
                child = childrenObj[child].instance;
                child.update({}, { selected: true });
                child.draw();
                const eventEmitter = new DiagramEventEmitter(this.instanceUuid);
                eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.SELECTED_ANCHORED_PLUGIN, {
                    anchorUuid: this.selected.key, pluginUuid: this.selected.uuid, anchorPosition: child.data.position, pluginId: child.data.id
                });
            }
        }

        /**
         * @description undoes the selection status of the previously selected elemenet
         * @param {*} currentSelection
         */
        undoPreviousSelection(currentSelection) {
            if (this.selected && (!currentSelection || (currentSelection && (this.selected.key !== currentSelection.key || this.selected.uuid !== currentSelection.uuid)))) {
                const childrenObj = this.plugins.get(this.selected.key).children;
                const children = Object.keys(childrenObj);
                let child = children.find(child => childrenObj[child].instance.uuid === this.selected.uuid);
                if (child) {
                    child = childrenObj[child].instance;
                    child.update({}, { selected: false });
                    child.draw();
                }
            }
        }

        /**
         * @description Sets the ConnectingLineHandler instance
         * @param {*} connectingLineHandler
         */
        setConnectingLineHandler(connectingLineHandler) {
            this.connectingLineHandler = connectingLineHandler;
        }

        /**
         * @description Sets the CellIndependentPluginHandler instance
         * @param {*} cellIndependentPluginHandler
         */
        setCellIndependentHandler(cellIndependentPluginHandler) {
            this.cellIndependentPluginHandler = cellIndependentPluginHandler;
        }

        /**
         * @description Updates the status of the moved anchored plugin
         */
        pluginWasMoved(uuid, anchor, childKeys, anchorPos, anchorSize, childIndex) {
            const child = anchor.children[childKeys[childIndex]];
            let options = { size: child.instance.size, position: anchorPos };
            const anchorOptions = { position: anchorPos, size: anchorSize };
            options = this.adjustPositionToPreferences(anchorOptions, child.target.position, child.target.offset);
            options = this.adjustSizeToPreferences(options, anchor.target.data);
            child.instance.update(options);
            const newlyCoveredCells = this.cellIndependentPluginHandler.getCoveredCells(child.instance.position, child.instance.size, this.grid, true).filter(cell => cell);
            const newlyCoveredCellsUuids = newlyCoveredCells.map(cell => cell.uuid);
            child.coveredCells = newlyCoveredCells;
            child.coveredCellsUuids = newlyCoveredCellsUuids;
            anchor.anchorPosition = anchorPos;
            this.plugins.set(uuid, anchor);
        }

        pluginRedrawed(uuid) {

        }

        /**
         * @description updates plugin instance on the plugins map
         */
        updatePluginInstance(instance) {
            const data = this.plugins.get(instance.uuid);
            if (!data) {
                return;
            }
            data.target.targetInstance = instance;
        }

        /**
         * @description called when the plugin that is anchored to gets updated
         * @param {String} uuid  - plugion uuid
         */
        pluginUpdated(uuid) {
            const plugin = this.plugins.get(uuid);
            if (!plugin) return;
            const keys = Object.keys(plugin.children);
            for (let i = 0; i < keys.length; i++) {
                const child = plugin.children[keys[i]];
                const anchorPos = child.target.targetInstance.getPosition();
                if (plugin.anchorPosition.x !== anchorPos.x || plugin.anchorPosition.y !== anchorPos.y) {
                    this.pluginWasMoved(uuid, plugin, keys, anchorPos, child.target.targetInstance.getSize(), i);
                }
            }
        }

        /**
         * @description Called when the cell is anchored to gets redrawed
         */
        cellDrawing(uuid) {
            const keys = this.plugins.keys();
            const pluginsAffected = [];
            for (const key of keys) {
                const plugin = this.plugins.get(key);
                if (!plugin.children) {
                    continue;
                }
                const childKeys = Object.keys(plugin.children);
                for (let i = 0; i < childKeys.length; i++) {
                    const child = plugin.children[childKeys[i]];
                    if (child.coveredCellsUuids.indexOf(uuid) !== -1) {
                        pluginsAffected.push(key);
                    }
                }
            }
            pluginsAffected.forEach(plugin => {
                for (const key in this.plugins.get(plugin).children) {
                    const child = this.plugins.get(plugin).children[key];
                    child.instance.draw();
                }
            });
        }

        /**
         * @description check if label touch anchoredPluigin and redraw anchored
         */
        checkForAnchoredTouch(labelDetails, labelWidth, labelProp) {
            const keys = this.plugins.keys();
            for (const key of keys) {
                const currentPlugin = this.plugins.get(key);
                if (!currentPlugin.children) {
                    continue;
                }
                const childKeys = Object.keys(currentPlugin.children);
                const labelXMin = labelDetails.label.x - labelWidth.labelWidth.width / 2 - labelProp.paddingLabelX - labelProp.dragPointLabelRadius;
                const labelXMax = labelDetails.label.x + labelWidth.labelWidth.width / 2;
                const labelYMin = labelWidth.secondLine ? labelDetails.label.y - parseInt(labelProp.fontLabel) - (parseInt(labelProp.paddingLabelTopBottom) * 3) : (labelDetails.label.y - parseInt(labelProp.paddingLabelTopBottom));
                const labelYMax = labelWidth.secondLine ? labelDetails.label.y + (parseInt(labelProp.fontLabel) + parseInt(labelProp.paddingLabelTopBottom) * 2) * 2 : (labelDetails.label.y + parseInt(labelProp.fontLabel) + parseInt(labelProp.paddingLabelTopBottom) * 2);

                for (let i = 0; i < childKeys.length; i++) {
                    const child = currentPlugin.children[childKeys[i]];
                    const anchoredMinX = child.instance.position.x - child.instance.size.width;
                    const anchoredMaxX = child.instance.position.x + child.instance.size.width;
                    const anchoredMinY = child.instance.position.y - child.instance.size.height;
                    const anchoredMaxY = child.instance.position.y + child.instance.size.height;

                    if ((labelXMin < anchoredMinX && anchoredMinX < labelXMax) || (labelYMin < anchoredMinY && anchoredMinY < labelYMax)
                        || (labelXMin < anchoredMaxX && anchoredMaxX < labelXMax) || (labelYMin < anchoredMaxY && anchoredMaxY < labelYMax)) {
                        child.instance.draw();
                    }
                }
            }
        }

        /**
         * @description adds a new anchored plugin
         */
        addPlugin(target, Factory, ctx, grid) {
            this.grid = grid;
            let options = { size: { ...target.targetInstance.getSize() }, position: target.targetInstance.getPosition() };
            const positionAdjustments = this.adjustPositionToPreferences(options, target.position, target.offset);
            options = positionAdjustments.options;
            options = this.adjustSizeToPreferences(options, target.data);
            target.data.position = positionAdjustments.pref;
            target.data.size = options.size;
            target.data.offset = target.offset || { x: 0, y: 0 };
            let targetData = this.plugins.get(target.targetUuid);
            if (!targetData) targetData = {};
            const instance = new Factory(options, ctx, target.data);
            if (!targetData.children) targetData.children = {};
            const coveredCells = this.cellIndependentPluginHandler.getCoveredCells(options.position, options.size, grid, true).filter(cell => cell);
            const coveredCellsUuids = coveredCells.map(cell => cell.uuid);
            targetData.children[instance.uuid] = {
                coveredCells, coveredCellsUuids, instance, target
            };
            targetData.anchorPosition = { ...target.targetInstance.getPosition() };
            targetData.target = target;
            instance.draw();
            this.plugins.set(target.targetUuid, targetData);
            return instance.uuid;
        }

        /**
         * @description Reseting the plugins map
         */
        resetingDataSet() {
            this.plugins = new Map();
        }

        /**
         * @description Updates plugin state and data. Called from @APIHandler
         */
        updatePluginStateAndData(data, grid) {
            if (!data) data = {};
            if (!data.options) data.options = {};
            if (!data.options.data) data.options.data = {};
            const anchorElem = this.plugins.get(data.anchorPluginUuid);
            if (!anchorElem) {
                // console.error(`Did not find anchor plugin with ID: ${data.anchorPluginUuid}`);
                return;
            }
            const elem = anchorElem.children[data.pluginUuid];
            if (!elem) {
                if (data.options.customUpdate) {
                    for (const key in anchorElem.children) {
                        if (data.options.hasOwnProperty(anchorElem.children[key].target.position)) {
                            this.updatePluginChildrenStateAndData(data, anchorElem.children[key], anchorElem, grid, { text: data.options[anchorElem.children[key].target.position] });
                        }
                    }
                } else {
                    console.error(`Did not find anchored plugin with ID: ${data.pluginUuid}`);
                }
            } else {
                this.updatePluginChildrenStateAndData(data, elem, anchorElem, grid);
            }
        }

        /**
         * @description Updates plugin children state and data. Called from @APIHandler
         */
        updatePluginChildrenStateAndData(data, elem, anchorElem, grid, customData) {
            // if update contains position, send position, otherwise take current position
            let positionToSet; let offsetToSet; let sizeToSet; let textToUpdate; let fillStyleToUpdate; let pluginTypeID; let options = {}; let
                positionAdjustments;
            if (customData) {
                elem.instance.update(options, null, { text: customData.text });
                options.position = elem.instance.position;
                options.size = elem.instance.size;
            } else {
                let position;
                positionToSet = data.options.position || elem.instance.data.position;
                offsetToSet = data.options.offset || elem.instance.data.offset || { x: 0, y: 0 };
                sizeToSet = data.options.data.size || elem.instance.size;
                textToUpdate = customData && customData.text ? customData.text : (data.options.data.text || elem.instance.data.text);
                fillStyleToUpdate = data.options.data.fillStyle || elem.instance.data.fillStyle;
                pluginTypeID = elem.instance.data.id;
                options = { position: anchorElem.target.targetInstance.getPosition(), size: anchorElem.target.targetInstance.getSize() };
                positionAdjustments = this.adjustPositionToPreferences(options, positionToSet, offsetToSet);
                options = positionAdjustments.options;
                position = positionAdjustments.pref;
                options = this.adjustSizeToPreferences(options, { size: sizeToSet });

                elem.instance.update(options, null, {
                    text: textToUpdate, position, fillStyle: fillStyleToUpdate, size: sizeToSet, offset: offsetToSet, id: pluginTypeID
                });
            }
            elem.coveredCells = this.cellIndependentPluginHandler.getCoveredCells(options.position, options.size, grid, true).filter(cell => cell);
            elem.coveredCellsUuids = elem.coveredCells.map(cell => { cell.draw(); return cell.uuid; });
            this.plugins.set(data.anchorPluginUuid, anchorElem);
        }

        /**
         * @description Adjusts the position to the preferences sent by the user
         * @param {Object} options - {position,size}
         * @param {String} pref - Prefered position
         * @param {Object} offset - {x,y} offset
         */
        adjustPositionToPreferences(options, pref, offset) {
            if (!offset) offset = { x: 0, y: 0 };
            const posiblePositions = this.getPossiblePositions(options);
            pref = pref || ANCHORED_PLUGIN_POSITIONS.TOP_LEFT;
            options.position = posiblePositions[pref];
            options.position.x += offset.x;
            options.position.y += offset.y;
            return { options, pref };
        }

        /**
        * @description Adjusts the size to the preferences sent by the user
        * @param {Object} options - {position,size}
        * @param {Object} data - {size, position}
        */
        adjustSizeToPreferences(options, data) {
            options.size.width = data && data.size && data.size.width ? ({ ...data.size }).width : (options.size.width / 2);
            options.size.height = data && data.size && data.size.height ? ({ ...data.size }).height : (options.size.height / 2);
            return options;
        }

        /**
         * @description returns the possible positions that the anchored plugins can be situated
         */
        getPossiblePositions(options) {
            const obj = {};
            const halfHeight = options.size.height / 2;
            const halfWidth = options.size.width / 2;
            obj[ANCHORED_PLUGIN_POSITIONS.TOP_LEFT] = options.position;
            obj[ANCHORED_PLUGIN_POSITIONS.CENTER_LEFT] = { x: options.position.x, y: options.position.y + halfHeight };
            obj[ANCHORED_PLUGIN_POSITIONS.BOTTOM_LEFT] = { x: options.position.x, y: options.position.y + options.size.height };

            obj[ANCHORED_PLUGIN_POSITIONS.TOP_CENTER] = { x: options.position.x + halfWidth, y: options.position.y };
            obj[ANCHORED_PLUGIN_POSITIONS.CENTER_CENTER] = { x: options.position.x + halfWidth, y: options.position.y + halfHeight };
            obj[ANCHORED_PLUGIN_POSITIONS.BOTTOM_CENTER] = { x: options.position.x + halfWidth, y: options.position.y + options.size.height };

            obj[ANCHORED_PLUGIN_POSITIONS.TOP_RIGHT] = { x: options.position.x + options.size.width, y: options.position.y };
            obj[ANCHORED_PLUGIN_POSITIONS.CENTER_RIGHT] = { x: options.position.x + options.size.width, y: options.position.y + halfHeight };
            obj[ANCHORED_PLUGIN_POSITIONS.BOTTOM_RIGHT] = { x: options.position.x + options.size.width, y: options.position.y + options.size.height };
            return obj;
        }

        /**
         * @description - Checks to see if the click was over a anchored plugin
         * @param {Object} payload  - {x,y} mouse position
         */
        clickedAnchoredPlugin(payload) {
            const keys = this.plugins.keys();
            for (const key of keys) {
                const anchor = this.plugins.get(key);
                const children = Object.keys(anchor.children);
                for (let i = 0; i < children.length; i++) {
                    const child = anchor.children[children[i]];
                    if (child.instance && child.instance.data && child.instance.data.text !== 0 && child.instance.pointInElement(payload)) {
                        return {
                            key, uuid: child.instance.uuid, dataCustomAchored: (child.instance.anchordTypeTotal || null), anchorPosition: child.instance.data.position
                        };
                    }
                }
            }
            return null;
        }

        /**
         * @description Destroys the reference
         * @param {String} instanceUuid
         */
        destroy(instanceUuid) {
            this.plugins = new Map();
            instance[instanceUuid] = null;
            delete instance[instanceUuid];
        }
    }
    return AnchoredPluginsHandler;
}());
